import React from "react";
import { Row, Col, Input } from "antd";
import { useSelector } from "react-redux";

const OrderDataTableFooter = () => {
  const footer = useSelector((s) => s.salesOrder.footerValues);
  const conversionRate = useSelector((s) => s.salesOrder.conversionRate);

  return (
    <Row gutter={16} style={{ marginTop: 20 }}>
      <Col span={6}>
        <div>Sub Total</div>
        <Input
          value={parseFloat(
            conversionRate ? footer.subtotal * conversionRate : footer.subtotal
          )?.toFixed(2)}
          disabled
        />
      </Col>
      <Col span={6}>
        <div>Total Tax</div>
        <Input
          value={parseFloat(
            conversionRate ? footer.totalTax * conversionRate : footer.totalTax
          )?.toFixed(2)}
          disabled
        />
      </Col>
      <Col span={6}>
        <div>Total Discount</div>
        <Input
          value={parseFloat(
            conversionRate ? footer.totalTax * conversionRate : footer.totalTax
          )?.toFixed(2)}
          disabled
        />
      </Col>
      <Col span={6}>
        <div>Grand Total</div>
        <Input
          value={parseFloat(
            conversionRate
              ? footer.grandTotal * conversionRate
              : footer.grandTotal
          )?.toFixed(2)}
          disabled
        />
      </Col>
    </Row>
  );
};

export default OrderDataTableFooter;
